import { Middleware } from "@reduxjs/toolkit";
import { BuilderState } from "@builder/store/slices/BuilderSlice/types";
import { Build } from "@common/build/types";

// Define the tracked actions for the Builder slice
const trackedActions = [
    //Base Layer
    "Builder/updateNodeProperty",
    "Builder/updateNodePropertyByNodeIdAndLayer",
    "Builder/addLayer",
    "Builder/deleteLayer",
    "Builder/setLayerName",
    "Builder/duplicateLayer",
    "Builder/setLayoutToCurrentPage",
    "Builder/setSpecialLayers",
    "Builder/removeSpecialLayer",
    //Node
    "Builder/addNode",
    "Builder/pasteHTML",
    "Builder/mergeJSXIntoNode",
    "Builder/mergeHTMLIntoNode",
    "Builder/deleteNode",
    "Builder/moveNode",
    "Builder/updateChildrenSize",
    //Render
    "Builder/updateDynamicDataType",
    "Builder/updateCondition",
    "Builder/setCondition",
    "Builder/updateConditionalActions",
    "Builder/removeConditionalActions",
    "Builder/updateNodeActions",
    "Builder/updateBuildActions",
    "Builder/updateActionBuilder",
    "Builder/deleteActionBuilder",
    "Builder/duplicateActionBuilder",
    "Builder/updateReceiptStyles",
    "Builder/updateReceiptSettings",
    "Builder/updateCashLedgerSettings",
    "Builder/updateEOSSettings",
    //Simple cart (To be removed)
    "Builder/updateSimpleCartShowTaxes",
    "Builder/updateSimpleCartMode",
    "Builder/updateSimpleCartExpandedNode",
    "Builder/updateSimpleCartExpandedMainBg",
    "Builder/updateSimpleCartExpandedTotalBg",
    "Builder/updateSimpleCartExpandedDividerColor",
    "Builder/updateSimpleCartExpandedWidth",
    "Builder/updateSimpleCartExpandedName",
    //Update node
    "Builder/clearBorderStyles",
    "Builder/copyNode",
    "Builder/copyTemplateNode",
    "Builder/pasteNodeFromJSON",
    "Builder/updateNodeProperty",
    "Builder/updateNodePropertyByNodeIdAndLayer",
    "Builder/addFontToAttributes",
    "Builder/setFontRoots",
    "Builder/batchEditNodes",
    "Builder/updateNodeQuery",
    //MISC
    "Builder/addBuildGlobalColor",
    "Builder/updateBuildGlobalColor",
    "Builder/deleteBuildGlobalColor",
    "Builder/updateDecimals",
    "Builder/attachGlobalBlock",
    "Builder/detachGlobalBlock"
];
const debounceDelay = 300;
let debounceTimeout: NodeJS.Timeout | null = null;
let queuedState: Build | null = null;

const buildStateMemoryMiddleware: Middleware = store => next => action => {
    const state: BuilderState = store.getState().builder;
    const result = next(action);

    if (!trackedActions.includes(action.type)) {
        return result;
    }

    const newState = store.getState().builder;

    if (JSON.stringify(state.build) === JSON.stringify(newState.build)) {
        return result;
    }

    queuedState = newState.build;

    if (debounceTimeout) {
        clearTimeout(debounceTimeout);
    }

    debounceTimeout = setTimeout(() => {
        if (queuedState && state?.build) {
            store.dispatch({
                type: "Builder/updateBuildHistory",
                payload: {
                    past: [
                        ...(newState.buildHistory.past.length > 9 ? newState.buildHistory.past.slice(1) : newState.buildHistory.past),
                        state.build
                    ],
                    future: []
                }
            });
        }
        queuedState = null;
    }, debounceDelay);

    return result;
};

export default buildStateMemoryMiddleware;
